import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function ConfirmModal({ show, handleClose, handleConfirm, title, message, confirmText, cancelText, variant }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Confirmación'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || '¿Estás seguro de que deseas continuar?'}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {cancelText || 'Cancelar'}
        </Button>
        <Button variant={variant || 'danger'} onClick={handleConfirm}>
          {confirmText || 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
